import { Box, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { isDarkMode, themeColors } from "../../utils/constants";
import "../../../stylesheets/chat_area.css";
import { useState, useEffect } from "react";

const ScrollDown = (props) => {
  const { executeScroll, showScrollDown, isDesktop, sidebarOffset } = props;

  const [shouldRender, setShouldRender] = useState(showScrollDown);
  const [animationClass, setAnimationClass] = useState(
    showScrollDown ? "visible" : "hidden"
  );

  const buttonPadding = isDesktop ? "4px 14px 0px 14px" : "8px 18px 4px 18px";

  useEffect(() => {
    if (showScrollDown) {
      setShouldRender(true);
      setAnimationClass("visible");
    } else {
      setAnimationClass("hidden");
      const t = setTimeout(() => setShouldRender(false), 1000); // match keyframes duration
      return () => clearTimeout(t);
    }
  }, [showScrollDown]);

  if (!shouldRender) return null;
  return (
    <Box sx ={{ height: '30px', marginBottom: '-30px' }}
    className={`scroll-down-container ${animationClass}`}>
      <Box
        sx={{
          width: "100%",
          marginBottom: "0px",
          opacity: 0.8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Tooltip title="Scroll Down">
          <IconButton size="small" aria-haspopup="true" onClick={executeScroll}>
            <Box
              sx={{
                padding: buttonPadding,
                borderRadius: "20px",
                backgroundColor: isDarkMode
                  ? themeColors.showHistoryContainerColor
                  : "#ECEEF3",
              }}
            >
              <ArrowUpwardIcon
                sx={{
                  fontSize: "18px",
                  color: themeColors.showHistoryColor,
                  transform: "rotate(180deg)",
                }}
              />
            </Box>
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};
export default ScrollDown;
